// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  defaultauth: '',
  firebaseConfig: {
    apiKey: 'AIzaSyBSNQDNzQLJLyJWnG40AO27_TY7gRkqjho',
    authDomain: 'test-authentication-4be35.firebaseapp.com',
    databaseURL: 'https://test-authentication-4be35.firebaseio.com',
    projectId: 'test-authentication-4be35',
    storageBucket: 'test-authentication-4be35.appspot.com',
    messagingSenderId: '679258537586',
    appId: '1:679258537586:web:00f41690d98a38435dcceb',
    measurementId: 'G-6L8TCTHC4H'
  },
  firebase: {
    apiKey: "AIzaSyDBOyruuQfXHFO0fSjAhCTVxMUEj4bq-u0",
    authDomain: "landsapp18.firebaseapp.com",
    databaseURL: "https://landsapp18.firebaseio.com",
    projectId: "landsapp18",
    storageBucket: "landsapp18.appspot.com",
    messagingSenderId: "907189105225",
    appId: "1:907189105225:web:448dea2cd96f12a5a74598"
  },


  // url_uu: 'https://auditdbgh.herokuapp.com/api/',
  url_uu: 'https://auditbackup.herokuapp.com/api/',

  // url_uu: 'http://localhost:5000/api/',

  url_login: 'https://dbaudit.herokuapp.com/api/',
  
  
  url: 'https://pprsdapi.herokuapp.com/api/'


// url_login: 'http://localhost:4000/api/',
   
  // url_login: 'http://localhost:5050/api/',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
